// src/components/NavBar.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../App.css';

export default function NavBar({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('userData'));
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // 현재 활성화된 경로 확인
  const isActive = (path) => {
    return location.pathname === path || 
           (path !== '/' && location.pathname.startsWith(path));
  };

  // 모바일 화면 크기 감지
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {/* 데스크톱 네비게이션 - 원래 디자인으로 복원 */}
      <nav className={`navbar desktop-nav ${isMobile ? 'hidden' : ''}`}>
        <ul>
          <li><button className="nav-btn" onClick={() => navigate('/search')}><span role="img" aria-label="search">🔍</span> 방 검색</button></li>
          <li><button className="nav-btn" onClick={() => navigate('/all-rooms')}><span role="img" aria-label="all">🏠</span> 전체 방</button></li>
          <li><button className="nav-btn" onClick={() => navigate('/rooms/create')}><span role="img" aria-label="plus">➕</span> 방 만들기</button></li>
          <li><button className="nav-btn" onClick={() => navigate('/board')}><span role="img" aria-label="board">📝</span> 게시판</button></li>
          <li><button className="nav-btn" onClick={() => navigate('/mypage')}><span role="img" aria-label="mypage">👤</span> 마이페이지</button></li>
          <li><button className="nav-btn nav-logout" onClick={onLogout}><span role="img" aria-label="logout">🚪</span> 로그아웃</button></li>
        </ul>
      </nav>

      {/* 모바일 네비게이션 - 개선된 디자인 유지 */}
      <nav style={{
        display: isMobile ? 'block' : 'none',
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%',
        background: 'white',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
        borderTop: '1px solid #f1f5f9',
        zIndex: 100,
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-around',
          padding: '0.5rem 0',
        }}>
          <button 
            onClick={() => navigate('/search')}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.25rem',
              background: 'transparent',
              border: 'none',
              padding: '0.5rem',
              minWidth: '4rem',
              color: isActive('/search') ? '#6366f1' : '#64748b',
              fontWeight: isActive('/search') ? '600' : '500',
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            검색
          </button>
          <button 
            onClick={() => navigate('/all-rooms')}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.25rem',
              background: 'transparent',
              border: 'none',
              padding: '0.5rem',
              minWidth: '4rem',
              color: isActive('/all-rooms') ? '#6366f1' : '#64748b',
              fontWeight: isActive('/all-rooms') ? '600' : '500',
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            전체
          </button>
          <button 
            onClick={() => navigate('/rooms/create')}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.25rem',
              background: 'transparent',
              border: 'none',
              padding: '0.5rem',
              minWidth: '4rem',
              color: isActive('/rooms/create') ? '#6366f1' : '#64748b',
              fontWeight: isActive('/rooms/create') ? '600' : '500',
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="16"/>
              <line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
            방 만들기
          </button>
          <button 
            onClick={() => navigate('/board')}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.25rem',
              background: 'transparent',
              border: 'none',
              padding: '0.5rem',
              minWidth: '4rem',
              color: isActive('/board') ? '#6366f1' : '#64748b',
              fontWeight: isActive('/board') ? '600' : '500',
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
              <polyline points="13 2 13 9 20 9"/>
            </svg>
            게시판
          </button>
          <button 
            onClick={() => navigate('/mypage')}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.25rem',
              background: 'transparent',
              border: 'none',
              padding: '0.5rem',
              minWidth: '4rem',
              color: isActive('/mypage') ? '#6366f1' : '#64748b',
              fontWeight: isActive('/mypage') ? '600' : '500',
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            마이페이지
          </button>
        </div>
      </nav>

      {/* 모바일에서만 하단 패딩 적용 */}
      {isMobile && <div style={{ paddingBottom: '70px' }}></div>}
    </>
  );
}
